module.exports = __webpack_public_path__ + "img/1.7bcaf6c3.jpg";